import dayjs from "dayjs";

export const formattedDate = (dayConvert: string): string => {
  const formatted = dayjs(dayConvert).format("DD.MM.YYYY");
  return formatted !== "Invalid Date" ? formatted : "-";
};

export const formatDateNumber = (number: number) => {
  return number?.toString().padStart(2, "0");
};
